import { Component } from "solid-js";

interface HotDealsIconProps {
  class?: string;
}

export const HotDealsIcon: Component<HotDealsIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M9.14185 9.70621L11.9834 11.2482L14.5262 3.79698C14.6842 3.27032 15.1689 2.90967 15.7188 2.90967C16.2687 2.90967 16.7534 3.27033 16.9114 3.79699L19.4542 11.2483L22.6852 9.53917C23.0081 9.32393 23.4128 9.27153 23.7799 9.39747C24.147 9.52341 24.4343 9.81327 24.557 10.1814L26.2706 14.226C29.2697 22.736 22.7348 28.7953 15.9517 28.7953C9.83723 28.7952 3.17744 23.3733 5.72668 14.7196L7.26998 10.3484C7.39271 9.9803 7.68006 9.69044 8.04711 9.56451C8.41417 9.43857 8.81895 9.49097 9.14185 9.70621Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9683 17.0964L13.6089 18.0546L15.1225 13.6192C15.2166 13.3057 15.5051 13.091 15.8325 13.091C16.1598 13.091 16.4483 13.3057 16.5424 13.6192L18.056 18.0546L19.9072 17.0342C20.0994 16.9061 20.3403 16.8749 20.5588 16.9499C20.7773 17.0249 20.9484 17.1974 21.0214 17.4165L22.1135 19.8272C23.8988 24.8929 20.0088 28.4997 15.9711 28.4997C12.3314 28.4997 8.36704 25.2722 9.88451 20.121L10.8541 17.4787C10.9271 17.2596 11.0982 17.087 11.3167 17.012C11.5352 16.9371 11.7761 16.9683 11.9683 17.0964Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
